// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"48":"a289c605","412":"6dfbfd9c","594":"32426e2d","981":"ed44d3d8"}[chunkId] + ".js";
};